import React from "react"
import camelCase from "lodash/camelCase"
import { getDisplayedImage, mapColumnSize } from "src/legacy/utils"

import AppStoreButtons from "legacy/components/shared/AppStoreButtons"
import Buttons from "./Buttons"
import { Element, Image, Text } from "legacy/components/shared/base"
import Grid from "legacy/components/shared/Grid"
import { Maybe } from "types/Maybe"
import { OneColumnType } from "types/shared-components"
import RichText from "legacy/components/shared/RichText"
import useBreakpoints from "src/legacy/hooks/useBreakpoints"

interface OwnProps {
  data: Maybe<OneColumnType>
}

export type OneColumnSectionProps = OwnProps

const OneColumnSection: React.FC<OneColumnSectionProps> = ({
  data,
}): React.ReactElement | null => {
  if (!data?.primary) return null

  const { breakpoint } = useBreakpoints()
  const {
    app_store_buttons,
    background_color,
    center_column_content,
    eyebrow,
    full_bleed_section,
    image,
    image_max_width = "100%",
    mobile_image,
    section_width,
    vertical_padding,
    wysiwyg,
  } = data.primary
  const bgColor = background_color ? camelCase(background_color) : "white"
  const columnSize = mapColumnSize(section_width)
  const imageData = getDisplayedImage(breakpoint, image, mobile_image) || {}
  const maxWidth = full_bleed_section ? "maxWidth" : "contentWidth"
  const padding = vertical_padding === "regular" ? ["40", "60", "90"] : "0"
  const shouldRenderRichText =
    wysiwyg?.richText && wysiwyg && wysiwyg.text && wysiwyg.text.length > 0
  const wysiwygColor = bgColor === "navy" ? "white" : "navy"
  const { height, width } = imageData?.dimensions || {}

  return (
    <Element bg={bgColor}>
      <Grid
        gridTemplateColumns="1col"
        maxWidth={maxWidth}
        textAlign={center_column_content ? "center" : "left"}
      >
        <Element
          gridColumnEnd={columnSize.gridColumnEnd}
          gridColumnStart={columnSize.gridColumnStart}
          m="0 auto"
          py={padding}
        >
          <Image
            aspectRatio={`${width} / ${height}`}
            display="block"
            imageData={imageData}
            m="0 auto"
            maxWidth={image_max_width || width}
          />
          {eyebrow && (
            <Text
              as="p"
              fontSize={["13", "text.captionCaps"]}
              lineHeight={["22px", "normal"]}
              my="20"
              variant="captionCaps"
            >
              {eyebrow}
            </Text>
          )}
          {shouldRenderRichText && (
            <RichText
              color={wysiwygColor}
              mt={["20", "50"]}
              render={wysiwyg?.richText}
            />
          )}
          {data?.items && <Buttons data={data?.items} />}
          {app_store_buttons ? (
            <Element mt="40">
              <AppStoreButtons
                desktopAlignment="center"
                mobileAlignment="center"
                useQRCode={true}
              />
            </Element>
          ) : null}
        </Element>
      </Grid>
    </Element>
  )
}

export default OneColumnSection
